import React from 'react';
import { availableAgents } from '../../../mocks/agents';
import { Button } from '../../../components/base/Button';

interface AgentsSectionProps {
  onAgentSelect: (agentId: string) => void;
}

export const AgentsSection: React.FC<AgentsSectionProps> = ({ onAgentSelect }) => {
  const scrollToDemo = () => {
    const element = document.getElementById('demo-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleViewDetails = (agentId: string) => {
    onAgentSelect(agentId);
    const element = document.getElementById('agent-details');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="agentes" className="py-32 bg-gradient-to-b from-gray-900 to-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <span className="text-xs font-semibold text-primary uppercase tracking-[0.2em] mb-4 block">
            Nuestros agentes
          </span>
          <h2 className="text-5xl font-display font-semibold text-white mb-4">
            Despliega tu Equipo de Élite Digital o Diséñalo a Medida
          </h2>
          <p className="text-lg text-white">
            Agentes especializados listos para integrarse a tu negocio
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {availableAgents.map((agent) => (
            <div 
              key={agent.id}
              className="bg-gradient-to-br from-gray-900 to-gray-800 border-2 border-gray-700 rounded-[32px] p-8 shadow-lg hover:shadow-2xl hover:shadow-primary/20 transition-all duration-300"
            >
              <div className="inline-block mb-6">
                <span className="text-[10px] font-semibold text-primary bg-primary/20 px-3 py-1.5 rounded-full uppercase tracking-wider">
                  Disponible
                </span>
              </div>
              
              <div className="w-24 h-24 rounded-full overflow-hidden mb-6 mx-auto shadow-lg">
                <img 
                  src={agent.image} 
                  alt={agent.name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <h3 className="text-3xl font-display font-bold text-white text-center mb-2">
                {agent.name}
              </h3>
              <p className="text-sm text-white text-center mb-6 min-h-[48px]">
                {agent.role}
              </p>
              
              <div className="space-y-3 mb-8">
                {agent.features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-base text-primary"></i>
                    </div>
                    <span className="text-xs text-white leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>
              
              <div className="space-y-3">
                <Button 
                  variant="primary" 
                  size="md"
                  onClick={scrollToDemo}
                >
                  Agenda tu demo
                </Button>
                <Button 
                  variant="outline" 
                  size="md" 
                  fullWidth
                  onClick={() => handleViewDetails(agent.id)}
                >
                  Ver detalles
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}